<template>
    <div>
        <PageTop></PageTop>
        <div class="mx-auto w-300 my-12 text-center">
            <input v-model="username" class="border-1 text-center border-solid border-bd text-16" type="text" placeholder="输入用户名"><br>
            <input v-model="passowrd" class="border-1 text-center border-solid border-bd text-16" type="password" placeholder="输入密码"><br>
            <button @pointerup="login" class="bg-bd text-bg px-4 py-2 text-16 mt-12">登录</button>
        </div>
    </div>
</template>
<script>
import PageTop from '@/components/PageTop.vue';

export default{
    components:{
        PageTop
    },
    data(){
        return{
            username:'',
            passowrd:''
        }
    },
    methods:{
       async login(){
            try{
                const res = await this.$axios.post('/admin/login',{
                    username:this.username,
                    password:this.passowrd
                })
                const token = res?.data?.token
                localStorage.setItem('token',token)
                alert('登录成功')
                this.$router.push({name:'home'})
            }catch(err){
                console.error(err);
                alert('登录失败')
            }
        }
    }
}
</script>
<style scoped>
</style>